import { loadAll } from "../actions/loadAll";
import { Group } from "../interface";

async function getGroups(): Promise<Group[]> {
    const groups = await loadAll("/groups/");
    return groups as Group[];
}

export { getGroups };
